export const phoneNumberFormat = (data) => {
  return !data
    ? ""
    : typeof data === "string" && data.length >= 10
    ? "(" + splice(8, 0, splice(3, 0, data, ") "), "-")
    : data;
};

export const extractOnlyDigits = (value) => value.replace(/[\D+]*/g, "");

export const formatDateString = (dateString) => {
  if (!dateString) {
    return "";
  }

  var date = new Date(dateString);

  return (
    ("0" + (date.getMonth() + 1)).slice(-2) +
    "/" +
    ("0" + date.getDate()).slice(-2) +
    "/" +
    ("000" + date.getFullYear()).slice(-4)
  );
};

const splice = (idx, rem, strdata, str) => {
  var strsplice =
    strdata.slice(0, idx) + str + strdata.slice(idx + Math.abs(rem));
  return strsplice;
};
